const mapPage = {
  pageWidth: 3000,
  pageHeight: 2400
}

export { mapPage }
